const DepartmentsTypes = {
    SET_DEPARTMENTS: "themet/setDepartments", // to set the list of all departments from the met api
    CLEAN_DEPARTMENTS: "themet/cleanDepartments", 
}

export default DepartmentsTypes;